export default "__VITE_ASSET__Cb5IP3vP__"